module.exports = __webpack_public_path__ + "img/line_bg1.741f35aa.png";